import script from "./TopLogoSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopLogoSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./TopLogoSidebar.vue?vue&type=style&index=0&id=3d25f4a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d25f4a6"]])

export default __exports__